import { Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { bookType, headerType, roleType } from 'src/Helpers/constant';
import { Reorder, getItemStyle, getMainBookNameFromClone, getQuestionListStyleNew } from 'src/Helpers/helperFunction';
import { contentTypeAction } from 'src/Redux/Action/htmlAction';
import { renderAction } from 'src/Redux/Action/renderAction';
import { bookCategoryService } from 'src/Services/ApiHandlers/bookCategoryService';
import { instructorServices } from 'src/Services/WebApiHandler/instructorServices';
import webBookServices from 'src/Services/WebApiHandler/webBookServices';
import Iconify from 'src/components/Iconify';
import BookUpdateHeaderModal from 'src/sections/PopUp/BookUpdateHeaderModal';
import BookHeaderModal from 'src/sections/PopUp/BooksHeaderModal';
import DeleteModal from 'src/sections/PopUp/DeleteModal';
import InstructorHeaderModal from 'src/sections/PopUp/InstuctorModal/InstructorHeaderModal';
import InstructorHeaderUpdateModal from 'src/sections/PopUp/InstuctorModal/InstructorHeaderUpdateModal';
import HtmlListing from './HtmlListing';

export default function DragListing(props) {
  const {
    setOpenChapterModal,
    actionState,
    setOpenUpdateChapterModal,
    setChapterElement,
    setOpenChapterDeleteModal,
    setChapterDeleteObject,
    showSidebar,
    menuType,
    getChapterContentCall,
    params,
    isClone,
  } = props;

  const state = useSelector((state) => state.contentHTML.htmlContent);
  const renderState = useSelector((state) => state.renderDetail.isRender);
  // const mainBookIdContent = useSelector((state) => state.mainBookIdDetail.main_book_id)
  const { htmltype } = state;
  const history = useNavigate();
  const [chapterListing, setChapterListing] = useState([]);
  const [typeOfBooks, setTypeOfBooks] = useState('');
  const [singleBookItem, setSingleBookItem] = useState();
  // const [mainBookId, setMainBookId] = useState(mainBookIdContent)
  const [renderType, setRenderType] = useState();
  const [draggingArray, setDraggingArray] = useState({
    chapter_array: [],
    header_one_array: [],
    header_two_array: [],
    header_three_array: [],
  });
  // state for header
  const [openModal, setOpenModal] = useState(false);
  const [openHeaderModal, setOpenHeaderModal] = useState(false);
  const [openUpdateHeaderModal, setOpenUpdateHeaderModal] = useState(false);
  const [headerContent, setHeaderContent] = useState({ data: '', type: '' });
  const [deleteHeaderObject, setDeleteHeaderObject] = useState();
  const [updateHeaderContent, setUpdateHeaderContent] = useState({
    dataHeader: '',
    type: '',
  });

  const createHeaderHandler = (data, typeheader) => {
    setOpenHeaderModal(true);
    setHeaderContent({
      data: data,
      type: typeheader,
    });
  };

  const dispatch = useDispatch();

  useEffect(() => {
    getCommonSequenceCall();
  }, [menuType, renderState]);

  const getCommonSequenceCall = () => {
    let bookname = params.id;
    if (isClone && menuType !== 'CUSTOM') {
      const mainBookName = getMainBookNameFromClone(bookname);
      bookname = mainBookName;
    }
    bookCategoryService.getStaticBookContent(bookname).then((response) => {
      if (response.code === 200) {
        dispatch(renderAction(false));
        let bookTypeCheck = response.data?.permissions?.bookType;
        let arrayNew = response.data?.permissions?.rolesData.find((item) => {
          if (bookType.main === bookTypeCheck && item.type === roleType.AUTHOR) {
            return item;
          } else if (bookType.clone === bookTypeCheck && item.type === roleType.INSTRUCTOR) {
            return item;
          } else if (bookType.main === bookTypeCheck && item.type === roleType.READER) {
            return item;
          } else if (bookType.main === bookTypeCheck && item.type === roleType.PUBLIC) {
            return item;
          }
        });
        setSingleBookItem(response.data);
        setRenderType(arrayNew);
        setDataTostate(response);
      }
    });
  };

  function setDataTostate(response) {
    response.data.index[0]?.chapter_data.length > 0 &&
      response.data.index[0].chapter_data.forEach((element) => {
        element['isCheck'] = false;
        element.header_data &&
          element.header_data.length > 0 &&
          element.header_data.forEach((headerOne) => {
            headerOne['isCheck'] = false;
            headerOne.header_data &&
              headerOne.header_data.length > 0 &&
              headerOne.header_data.forEach((headerTwo) => {
                headerTwo['isCheck'] = false;
                headerTwo.header_data &&
                  headerTwo.header_data.length > 0 &&
                  headerTwo.header_data.forEach((headerThree) => {
                    headerThree['isCheck'] = false;
                  });
              });
          });
      });

    setChapterListing(response.data.index[0]?.chapter_data);
  }

  const onDragEnd = async () => {
    let isAuthor = renderType.type === roleType.AUTHOR ? true : false;

    let chapterCall = isAuthor ? webBookServices.swapChapter : instructorServices.swapChapter;
    let HeaderOneCall = isAuthor ? webBookServices.swapHeaderOne : instructorServices.swapHeaderOne;
    let HeaderTwoCall = isAuthor ? webBookServices.swapHeaderTwo : instructorServices.swapHeaderTwo;
    let HeaderThreeCall = isAuthor ? webBookServices.swapHeaderThree : instructorServices.swapHeaderThree;

    let responseCall;

    if (typeOfBooks == 'CHAPTERS') {
      let postData = {
        swap_content: draggingArray.chapter_array,
      };
      responseCall = await chapterCall(postData);
    } else if (typeOfBooks == 'HEADER_ONE') {
      let postData = {
        swap_content: draggingArray.header_one_array,
      };
      responseCall = await HeaderOneCall(postData);
    } else if (typeOfBooks == 'HEADER_TWO') {
      let postData = {
        swap_content: draggingArray.header_two_array,
      };
      responseCall = await HeaderTwoCall(postData);
    } else if (typeOfBooks == 'HEADER_THREE') {
      let postData = {
        swap_content: draggingArray.header_three_array,
      };
      responseCall = await HeaderThreeCall(postData);
    }
    if (responseCall.status === true) {
      toast.success(responseCall.message);
      setDraggingArray({
        chapter_array: [],
        header_one_array: [],
        header_two_array: [],
        header_three_array: [],
      });
    } else {
      toast.error(responseCall.message);
      setDraggingArray({
        chapter_array: [],
        header_one_array: [],
        header_two_array: [],
        header_three_array: [],
      });
    }
  };

  const onDragEnding = (result) => {
    if (!result.destination) {
      return;
    }
    setTypeOfBooks(result.type?.type);
    if (result.type?.type === 'CHAPTERS') {
      const chapter = Reorder(chapterListing, result.source.index, result.destination.index);
      const new_array = [];
      for (let i = 0; i < chapter.length; i++) {
        new_array.push({ _id: chapter[i]?._id, sequence: i + 1 });
      }
      setDraggingArray({
        ...draggingArray,
        chapter_array: new_array,
      });
      setChapterListing(chapter);
    } else if (result.type.type === 'HEADER_ONE') {
      const nestedHeader = Reorder(
        chapterListing[parseInt(result.type.index, 10)]?.header_data,
        result.source.index,
        result.destination.index
      );
      const chapter = JSON.parse(JSON.stringify(chapterListing));
      chapter[result.type.index].header_data = nestedHeader;

      const new_array = [];
      for (let i = 0; i < nestedHeader.length; i++) {
        new_array.push({ _id: nestedHeader[i]?._id, sequence: i + 1 });
      }

      setDraggingArray({
        ...draggingArray,
        header_one_array: new_array,
      });
      setChapterListing(chapter);
    } else if (result.type?.type === 'HEADER_TWO') {
      const nestedHeadertwo = Reorder(
        chapterListing[result.type.index]?.header_data[parseInt(result.type.headerindex, 10)]?.header_data,
        result.source.index,
        result.destination.index
      );
      const chapter = JSON.parse(JSON.stringify(chapterListing));
      chapter[result.type.index].header_data[result.type.headerindex].header_data = nestedHeadertwo;
      const new_array = [];
      for (let i = 0; i < nestedHeadertwo.length; i++) {
        new_array.push({ _id: nestedHeadertwo[i]?._id, sequence: i + 1 });
      }
      setDraggingArray({
        ...draggingArray,
        header_two_array: new_array,
      });
      setChapterListing(chapter);
    } else if (result.type?.type === 'HEADER_THREE') {
      const nestedHeaderthree = Reorder(
        chapterListing[result.type.index]?.header_data[result.type.headerindex]?.header_data[
          parseInt(result.type.headertwoindex, 10)
        ].header_data,
        result.source.index,
        result.destination.index
      );
      const chapter = JSON.parse(JSON.stringify(chapterListing));
      chapter[result.type.index].header_data[result.type.headerindex].header_data[
        result.type.headertwoindex
      ].header_data = nestedHeaderthree;

      const new_array = [];
      for (let i = 0; i < nestedHeaderthree.length; i++) {
        new_array.push({ _id: nestedHeaderthree[i]?._id, sequence: i + 1 });
      }
      setDraggingArray({
        ...draggingArray,
        header_three_array: new_array,
      });
      setChapterListing(chapter);
    }
  };

  const deleteHandler = () => {
    let postData = {
      book_id: singleBookItem?._id,
    };

    let isAuthor = renderType.type === roleType.AUTHOR ? true : false;
    let deleteCall = isAuthor ? webBookServices.deleteChapterHeaderApi : instructorServices.deleteChapterHeaderApi;

    deleteCall(deleteHeaderObject?.type, deleteHeaderObject?._id, postData)
      .then((response) => {
        if (response.code === 200) {
          setOpenModal(false);
          toast.success(response.message);
          history(`/library/${params.id}`);
        } else {
          setOpenModal(false);
          toast.success(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const urlBookName = isClone ? params.id : singleBookItem?.slug;

  return (
    <div className={!showSidebar ? 'sidebar-collapse active' : 'sidebar-collapse'}>
      <div className="chapterListing reusable_drag_listing">
        <div className="my-3 mx-3 d-flex justify-content-between align-items-center">
          <h6>{menuType}</h6>
          {renderType?.type === roleType.AUTHOR || renderType?.type === roleType.INSTRUCTOR ? (
            <div>
              <Button onClick={() => onDragEnd()} className="default-black-btn me-2 px-2 mt-0">
                Save TOC
              </Button>
              {actionState.add && (
                <Button
                  variant="contained"
                  type="button"
                  onClick={() => setOpenChapterModal(true)}
                  startIcon={<Iconify icon={'eva:plus-fill'} className="user-btn" />}
                  className="p-2"
                >
                  Chapter
                </Button>
              )}
            </div>
          ) : (
            ''
          )}
        </div>

        {renderType?.type === roleType.AUTHOR || (renderType?.type === roleType.INSTRUCTOR && menuType === 'CUSTOM') ? (
          <DragDropContext onDragEnd={(e) => onDragEnding(e)}>
            <Droppable droppableId="droppable" type={{ index: 'NULL', type: 'CHAPTERS' }}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={{ maxHeight: '50vh', overflowY: 'auto', ...getQuestionListStyleNew(snapshot.isDraggingOver) }}
                >
                  {chapterListing.length > 0 &&
                    chapterListing.map((element, index) => {
                      return (
                        <Draggable key={element._id} draggableId={element._id} index={index}>
                          {(provided, snapshot) => (
                            <div>
                              <div
                                className="d-flex my-2"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={() => {
                                  let array = [...chapterListing];
                                  array[index].isCheck = !element.isCheck;
                                  setChapterListing(array);
                                  dispatch(
                                    contentTypeAction({
                                      renderType: renderType,
                                      id: singleBookItem?._id,
                                      htmltype: menuType,
                                      mainid: element._id,
                                      type: element.type ? element.type : 'chapter',
                                      routerType: 'CHAPTER',
                                    })
                                  );
                                }}
                                id="draggable"
                                style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                              >
                                {element.header_data.length > 0 ? (
                                  <span>
                                    {element.isCheck ? (
                                      <Iconify icon="eva:arrow-down-fill" width={24} height={24} />
                                    ) : (
                                      <Iconify icon="eva:arrow-right-fill" width={24} height={24} />
                                    )}
                                  </span>
                                ) : (
                                  <span>
                                    <Iconify icon="eva:arrow-right-fill" width={24} height={24} />
                                  </span>
                                )}

                                <span onClick={() => history(`/library/${urlBookName}/${element.slug}`)}>
                                  {element.chapter_name || element.chapter_name_clone}
                                </span>

                                <div className="ms-auto">
                                  {actionState.add && (
                                    <Tooltip title="Header first" placement="top-start">
                                      <span onClick={() => createHeaderHandler(element, headerType.header1)}>
                                        <Iconify className="text-primary mx-1 user-btn" icon={'eva:plus-fill'} />
                                      </span>
                                    </Tooltip>
                                  )}
                                  {actionState.edit && (
                                    <Iconify
                                      className="text-primary mx-1 user-btn"
                                      icon={'eva:edit-fill'}
                                      onClick={() => {
                                        setOpenUpdateChapterModal(true);
                                        setChapterElement(element);
                                      }}
                                    />
                                  )}
                                  {actionState.delete && (
                                    <Iconify
                                      className="text-danger mx-1 user-btn"
                                      icon={'eva:trash-fill'}
                                      onClick={() => {
                                        setOpenChapterDeleteModal(true);
                                        setChapterDeleteObject(element);
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                              {element.isCheck && element.header_data.length > 0 && (
                                <Droppable droppableId={`${element._id}`} type={{ index: index, type: 'HEADER_ONE' }}>
                                  {(provided, snapshot) => (
                                    <div ref={provided.innerRef}>
                                      {element.header_data.map((headerone, hkeyone) => {
                                        return (
                                          <Draggable key={headerone._id} draggableId={headerone._id} index={hkeyone}>
                                            {(provided, snapshot) => (
                                              <div>
                                                <div
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  className="d-flex my-3 ms-3"
                                                  onClick={(e) => {
                                                    let array = [...chapterListing];
                                                    array[index].header_data[hkeyone].isCheck = !headerone.isCheck;
                                                    setChapterListing(array);
                                                    dispatch(
                                                      contentTypeAction({
                                                        renderType: renderType,
                                                        id: singleBookItem?._id,
                                                        htmltype: htmltype,
                                                        mainid: headerone._id,
                                                        type: headerone.type ? headerone.type : 'chapter',
                                                        routerType: 'HEADER',
                                                      })
                                                    );
                                                  }}
                                                >
                                                  {headerone.header_data.length > 0 && (
                                                    <span>
                                                      {headerone.isCheck ? (
                                                        <Iconify icon="eva:arrow-down-fill" width={24} height={24} />
                                                      ) : (
                                                        <Iconify icon="eva:arrow-right-fill" width={24} height={24} />
                                                      )}
                                                    </span>
                                                  )}

                                                  <span
                                                    onClick={() =>
                                                      history(
                                                        `/library/${urlBookName}/${element?.slug}/${headerone?.slug}`
                                                      )
                                                    }
                                                  >
                                                    {headerone.header_name}
                                                  </span>

                                                  <div className="ms-auto">
                                                    {actionState.add && (
                                                      <Tooltip title="Header first" placement="top-start">
                                                        <span
                                                          onClick={() =>
                                                            createHeaderHandler(headerone, headerType.header2)
                                                          }
                                                        >
                                                          <Iconify
                                                            className="text-primary mx-1 user-btn"
                                                            icon={'eva:plus-fill'}
                                                          />
                                                        </span>
                                                      </Tooltip>
                                                    )}
                                                    {actionState.edit && (
                                                      <Iconify
                                                        className="text-primary mx-1 user-btn"
                                                        icon={'eva:edit-fill'}
                                                        onClick={() => {
                                                          setOpenUpdateHeaderModal(true);
                                                          setUpdateHeaderContent({
                                                            dataHeader: headerone,
                                                            type: headerType.header1,
                                                          });
                                                        }}
                                                      />
                                                    )}
                                                    {actionState.delete && (
                                                      <Iconify
                                                        className="text-danger mx-1 user-btn"
                                                        icon={'eva:trash-fill'}
                                                        onClick={() => {
                                                          setOpenModal(true);
                                                          setDeleteHeaderObject(headerone);
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </div>

                                                {headerone.isCheck && headerone.header_data.length > 0 && (
                                                  <Droppable
                                                    droppableId={`${headerone._id}`}
                                                    type={{
                                                      index: index,
                                                      headerindex: hkeyone,
                                                      type: 'HEADER_TWO',
                                                    }}
                                                  >
                                                    {(provided, snapshot) => (
                                                      <div ref={provided.innerRef}>
                                                        {headerone.header_data.map((headertwo, hkeytwo) => {
                                                          return (
                                                            <Draggable
                                                              key={headertwo._id}
                                                              draggableId={headertwo._id}
                                                              index={hkeytwo}
                                                            >
                                                              {(provided, snapshot) => (
                                                                <div>
                                                                  <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className="d-flex my-3 ms-5"
                                                                    onClick={() => {
                                                                      let array = [...chapterListing];
                                                                      array[index].header_data[hkeyone].header_data[
                                                                        hkeytwo
                                                                      ].isCheck = !headertwo.isCheck;
                                                                      setChapterListing(array);
                                                                      dispatch(
                                                                        contentTypeAction({
                                                                          renderType: renderType,
                                                                          id: singleBookItem?._id,
                                                                          htmltype: htmltype,
                                                                          mainid: headertwo._id,
                                                                          type: headertwo.type
                                                                            ? headertwo.type
                                                                            : 'chapter',
                                                                          routerType: 'HEADER',
                                                                        })
                                                                      );
                                                                    }}
                                                                  >
                                                                    {headertwo.header_data.length > 0 && (
                                                                      <span>
                                                                        {headertwo.isCheck ? (
                                                                          <Iconify
                                                                            icon="eva:arrow-down-fill"
                                                                            width={24}
                                                                            height={24}
                                                                          />
                                                                        ) : (
                                                                          <Iconify
                                                                            icon="eva:arrow-right-fill"
                                                                            width={24}
                                                                            height={24}
                                                                          />
                                                                        )}
                                                                      </span>
                                                                    )}

                                                                    <span
                                                                      onClick={() =>
                                                                        history(
                                                                          `/library/${urlBookName}/${element?.slug}/${headerone?.slug}/${headertwo?.slug}`
                                                                        )
                                                                      }
                                                                    >
                                                                      {headertwo.header_name}
                                                                    </span>

                                                                    <div className="ms-auto">
                                                                      {actionState.add && (
                                                                        <Tooltip
                                                                          title="Header first"
                                                                          placement="top-start"
                                                                        >
                                                                          <span
                                                                            onClick={() =>
                                                                              createHeaderHandler(
                                                                                headertwo,
                                                                                headerType.header3
                                                                              )
                                                                            }
                                                                          >
                                                                            <Iconify
                                                                              className="text-primary mx-1 user-btn"
                                                                              icon={'eva:plus-fill'}
                                                                            />
                                                                          </span>
                                                                        </Tooltip>
                                                                      )}
                                                                      {actionState.edit && (
                                                                        <Iconify
                                                                          className="text-primary mx-1 user-btn"
                                                                          icon={'eva:edit-fill'}
                                                                          onClick={() => {
                                                                            setOpenUpdateHeaderModal(true);
                                                                            setUpdateHeaderContent({
                                                                              dataHeader: headertwo,
                                                                              type: headerType.header2,
                                                                            });
                                                                          }}
                                                                        />
                                                                      )}
                                                                      {actionState.delete && (
                                                                        <Iconify
                                                                          className="text-danger mx-1 user-btn"
                                                                          icon={'eva:trash-fill'}
                                                                          onClick={() => {
                                                                            setOpenModal(true);
                                                                            setDeleteHeaderObject(headertwo);
                                                                          }}
                                                                        />
                                                                      )}
                                                                    </div>
                                                                  </div>

                                                                  {/* header 3 start here */}

                                                                  {headertwo.isCheck &&
                                                                    headertwo.header_data.length > 0 && (
                                                                      <Droppable
                                                                        droppableId={`${headertwo._id}`}
                                                                        type={{
                                                                          index: index,
                                                                          headerindex: hkeyone,
                                                                          headertwoindex: hkeytwo,
                                                                          type: 'HEADER_THREE',
                                                                        }}
                                                                      >
                                                                        {(provided, snapshot) => (
                                                                          <div ref={provided.innerRef}>
                                                                            {headertwo.header_data.map(
                                                                              (headerthree, hkeythree) => {
                                                                                return (
                                                                                  <Draggable
                                                                                    key={headerthree._id}
                                                                                    draggableId={headerthree._id}
                                                                                    index={hkeythree}
                                                                                  >
                                                                                    {(provided, snapshot) => (
                                                                                      <div
                                                                                        style={{
                                                                                          marginLeft: '85px',
                                                                                        }}
                                                                                      >
                                                                                        <div
                                                                                          ref={provided.innerRef}
                                                                                          {...provided.draggableProps}
                                                                                          className="d-flex my-3"
                                                                                          onClick={() => {
                                                                                            let array = [
                                                                                              ...chapterListing,
                                                                                            ];
                                                                                            array[index].header_data[
                                                                                              hkeyone
                                                                                            ].header_data[
                                                                                              hkeythree
                                                                                            ].isCheck =
                                                                                              !headerthree.isCheck;
                                                                                            setChapterListing(array);
                                                                                            dispatch(
                                                                                              contentTypeAction({
                                                                                                renderType: renderType,
                                                                                                id: singleBookItem?._id,
                                                                                                htmltype: htmltype,
                                                                                                mainid: headerthree._id,
                                                                                                type: headerthree.type
                                                                                                  ? headerthree.type
                                                                                                  : 'chapter',
                                                                                                routerType: 'HEADER',
                                                                                              })
                                                                                            );
                                                                                          }}
                                                                                        >
                                                                                          <span
                                                                                            {...provided.dragHandleProps}
                                                                                            onClick={() =>
                                                                                              history(
                                                                                                `/library/${urlBookName}/${element?.slug}/${headerone?.slug}/${headertwo?.slug}/${headerthree?.slug}`
                                                                                              )
                                                                                            }
                                                                                          >
                                                                                            {headerthree.header_name}
                                                                                          </span>

                                                                                          <div className="ms-auto">
                                                                                            {actionState.edit && (
                                                                                              <Iconify
                                                                                                className="text-primary mx-1"
                                                                                                icon={'eva:edit-fill'}
                                                                                                onClick={() => {
                                                                                                  setOpenUpdateHeaderModal(
                                                                                                    true
                                                                                                  );
                                                                                                  setUpdateHeaderContent(
                                                                                                    {
                                                                                                      dataHeader:
                                                                                                        headerthree,
                                                                                                      type: headerType.header3,
                                                                                                    }
                                                                                                  );
                                                                                                }}
                                                                                              />
                                                                                            )}
                                                                                            {actionState.delete && (
                                                                                              <Iconify
                                                                                                className="text-danger mx-1"
                                                                                                icon={'eva:trash-fill'}
                                                                                                onClick={() => {
                                                                                                  setOpenModal(true);
                                                                                                  setDeleteHeaderObject(
                                                                                                    headerthree
                                                                                                  );
                                                                                                }}
                                                                                              />
                                                                                            )}
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>
                                                                                    )}
                                                                                  </Draggable>
                                                                                );
                                                                              }
                                                                            )}
                                                                            {provided.placeholder}
                                                                          </div>
                                                                        )}
                                                                      </Droppable>
                                                                    )}

                                                                  {/* header 3 end here */}
                                                                </div>
                                                              )}
                                                            </Draggable>
                                                          );
                                                        })}
                                                        {provided.placeholder}
                                                      </div>
                                                    )}
                                                  </Droppable>
                                                )}
                                              </div>
                                            )}
                                          </Draggable>
                                        );
                                      })}
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </Droppable>
                              )}
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <HtmlListing
            chapterListing={chapterListing}
            setChapterListing={setChapterListing}
            singleBookItem={singleBookItem}
            menuType={menuType}
            isClone={isClone}
            scrollbar={true}
          />
        )}
      </div>

      {renderState?.type === roleType.AUTHOR && (
        <>
          <BookHeaderModal
            open={openHeaderModal}
            setOpen={setOpenHeaderModal}
            bookId={singleBookItem?._id}
            headerdata={headerContent}
            getChapterHeader={getChapterContentCall}
          />
          <BookUpdateHeaderModal
            typeOfMenu={htmltype}
            open={openUpdateHeaderModal}
            setOpen={setOpenUpdateHeaderModal}
            bookId={singleBookItem?._id}
            headerdata={updateHeaderContent}
            getChapterHeader={getChapterContentCall}
          />
        </>
      )}
      <DeleteModal setOpen={setOpenModal} open={openModal} deleteHandler={deleteHandler} />

      {renderState?.type === roleType.INSTRUCTOR && menuType === 'CUSTOM' ? (
        <div>
          <InstructorHeaderModal
            open={openHeaderModal}
            setOpen={setOpenHeaderModal}
            bookId={singleBookItem?._id}
            headerdata={headerContent}
            getChapterHeader={getChapterContentCall}
          />
          <InstructorHeaderUpdateModal
            typeOfMenu={menuType}
            open={openUpdateHeaderModal}
            setOpen={setOpenUpdateHeaderModal}
            bookId={singleBookItem?._id}
            headerdata={updateHeaderContent}
            getChapterHeader={getChapterContentCall}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
